import React, { useRef } from 'react'
import { useSelector } from 'react-redux'
import { OverlayPanel } from 'primereact/overlaypanel'

import { getFullName } from '../utils'


const PermDetailsWrapper = (props) => {
    let {displayComponent, uniqueId, permissions, permittedCompanyRoleIds, permittedExceptionUserRoleIds, permittedExceptionNegitiveUserRoleIds, visible} = props

    const op = useRef(null)
    const hideTimeoutRef = useRef(null)

    const userDetails = useSelector(state => state.userDetails)
    const companyUsers = userDetails.companyDetails?.companyUsers

    const renderPermittedTo = () => {
        const permittedCompanyRoleNames = []
        permittedCompanyRoleIds.map(eachPermittedCompanyRoleId => {
            const relatedCompanyRole = userDetails.companyDetails.companyRoles.find(eachCompanyRole => eachCompanyRole.companyRoleId === eachPermittedCompanyRoleId)
            if(relatedCompanyRole){
                permittedCompanyRoleNames.push(relatedCompanyRole.companyRoleName)
            }
        })
        
        const exemptedUserNames = []
        const exemptedNegitiveUserNames = []
        permittedExceptionUserRoleIds.map(eachUserRoleId => {
            const relatedUser = companyUsers.find(eachUser => eachUser.userRoles.filter(eachUserRole => eachUserRole.userRoleId === eachUserRoleId && eachUserRole.statusId === 1).map(eachUserRole => eachUserRole.userRoleId))
            if(relatedUser){
                exemptedUserNames.push(getFullName(relatedUser.firstName, relatedUser.lastName))
            }
        })
        permittedExceptionNegitiveUserRoleIds.map(eachUserRoleId => {
            const relatedUser = companyUsers.find(eachUser => eachUser.userRoles.filter(eachUserRole => eachUserRole.userRoleId === eachUserRoleId && eachUserRole.statusId === 1).map(eachUserRole => eachUserRole.userRoleId))
            if(relatedUser){
                exemptedNegitiveUserNames.push(getFullName(relatedUser.firstName, relatedUser.lastName))
            }
        })

        return (
            <div>
                { developerRole ? <p style={{ margin: 0, padding: 0, fontSize: "12px" }}>ID: <span className='font-semibold'>#{permissions.join(", #")}</span></p> : null }
                {permittedCompanyRoleNames.length ? 
                    <p style={{ margin: 0, padding: 0, fontSize: "12px" }}>Permitted roles: &nbsp;
                        <span className='font-semibold' style={{ fontSize: "11px" }}>{permittedCompanyRoleNames.join(", ")}</span>
                    </p> : null 
                }
                {exemptedUserNames.length || exemptedNegitiveUserNames.length ? 
                    <p style={{ margin: 0, padding: 0, fontSize: "12px" }}>Exempted users: &nbsp;
                        <span className='font-semibold' style={{ fontSize: "11px", color: "green" }}>{exemptedUserNames.join(", ")}</span> &nbsp; 
                        <span className='font-semibold' style={{ fontSize: "11px", color: "red" }}>{exemptedNegitiveUserNames.join(", ")}</span>
                    </p> : null
                }
            </div>
        )
    }
    
    const handleMouseEnter = (e) => {
        if (hideTimeoutRef.current) clearTimeout(hideTimeoutRef.current) 
        op.current.show(e)
    }

    const handleMouseLeave = () => {
        hideTimeoutRef.current = setTimeout(() => {
            op.current?.hide()
        }, 200) 
    }

    const handlePanelMouseLeave = () => {
        hideTimeoutRef.current = setTimeout(() => {
            op.current?.hide()
        }, 10) 
    }

    const developerRole = userDetails.activeCompanyRoleId === 1 //userDetails.rolesList.find(eachUserRole => eachUserRole.companyRoleId === 1)

    let isPermDetailsVisible = false
    if(developerRole){
        isPermDetailsVisible = true
    }
    if(visible){
        isPermDetailsVisible = true
    }

    if(!isPermDetailsVisible) {
        return displayComponent
    }

    if(!permittedExceptionUserRoleIds.length && !permittedCompanyRoleIds.length){
        return displayComponent
    }
 
    return (
        <>
            <div
                id={`perm-display-wrapper-${uniqueId}`}
                className='pm-details-wrapper'
                onClick={(e) => op.current.toggle(e)}
                onMouseEnter={handleMouseEnter}
                onMouseLeave={handleMouseLeave}
            >
                {displayComponent}
            </div>
            <OverlayPanel
                className='perm-details-overlay-panel'
                target={`#perm-display-wrapper-${uniqueId}`}
                ref={op}
                onMouseEnter={() => clearTimeout(hideTimeoutRef.current)}
                onMouseLeave={handlePanelMouseLeave}
            >
                {renderPermittedTo(developerRole)}
            </OverlayPanel>
        </>
    )
} 

export default PermDetailsWrapper
